import styled from 'styled-components'
import {
  FormControl as MuiFormControl,
  FormHelperText as MuiFormHelperText,
} from '@material-ui/core'

export const FormControl = styled(MuiFormControl)`
  width: 100%;
`

export const FormHelperText = styled(MuiFormHelperText)`
  &.MuiFormHelperText-root {
    color: #f46152;
  }
`
